import {
  keepPreviousData,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';

import { getFilteredInsightsProjects } from '@/features/insights/api/get-filtered-insights-projects';
import { useInsightsFilterStore } from '@/features/insights/store/use-insights-hub-filter';
import { useCurrentOrg } from '@/features/org/hooks/use-org';
import { Project } from '@/shared/types/api';

type QueryResult = (Project & { contractors?: unknown[] })[];

type Props = {
  queryProps?: UseQueryOptions<QueryResult, unknown, QueryResult>;
};

export function getFilteredInsightsProjectsQueryKey(orgId?: number) {
  return ['insightsProjects', 'filtered', orgId];
}

export const useInsightsProjectsFiltered = ({ queryProps }: Props = {}) => {
  const { data: org, isLoading: isOrgLoading } = useCurrentOrg();
  const { projectIds, subprojectIds, fromDate, toDate } =
    useInsightsFilterStore();

  const filters = {
    projectIds: projectIds?.map((id) => Number(id)),
    subprojectIds: subprojectIds?.map((id) => Number(id)),
    dateFrom: fromDate,
    dateTo: toDate,
  };

  return useQuery({
    ...queryProps,
    placeholderData: keepPreviousData,
    queryKey: [...getFilteredInsightsProjectsQueryKey(org?.id), filters],
    queryFn: async () => {
      if (isOrgLoading || !org) {
        return [];
      }

      return getFilteredInsightsProjects({ orgId: org.id, filters });
    },
    enabled: !isOrgLoading && !!org,
  });
};
